
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import GET_TITLES from "@/apollo/autocomplete-queries/GetTitles.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import {Query_RootUser_ProfileArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      titles: {
        query: GET_TITLES,
        variables() {
          return this.titleAutocompleteFilter;
        },
        update(data) {
          return data.user_profile;
        },
        skip() {
          return !this.titleSearchString;
        },
      },
    },
  })

  export default class TitlesMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
  @Prop({ type: String, default: "Select Titles" }) readonly placeholder?: string;

    titles: DropdownOption[] = [];
    titleSearchString = "";
  get placeholderText(): string {
    return this.placeholder;
  }
    get mappedTitleValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get titleAutocompleteFilter(): Query_RootUser_ProfileArgs {
      const conditions: any[] = [
        { 
          job_title: { 
            _ilike: `%${this.titleSearchString}%`
          }, 
        },
        { 
          job_title: {
            _is_null: false } 
        },
      ]; 

      if (this.mappedTitleValue.length) {
        conditions.push(
          {
            job_title: { 
              _nin: this.mappedTitleValue 
            }, 
          },
        );
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val)
    }
  }
